"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnityContext = void 0;
var unity_1 = require("./components/unity");
var unity_context_1 = require("./library/unity-context");
Object.defineProperty(exports, "UnityContext", { enumerable: true, get: function () { return unity_context_1.UnityContext; } });
// The Unity component
exports.default = unity_1.Unity;
//# sourceMappingURL=index.js.map